import apiClient, { safeJson } from '@/api/client';
import {
    DeleteWorkTemplateResponse,
    GetWorkTemplatesParams,
    GetWorkTemplatesResponse,
    PatchWorkTemplateBody,
    PatchWorkTemplateResponse,
    PostWorkTemplateBody,
    PostWorkTemplateResponse,
} from './types';

/**
 * @method get
 * @brief 센터의 근무 템플릿 목록 조회
 */
export const getWorkTemplates = async ({ centerId }: GetWorkTemplatesParams) => {
    const res = await apiClient.get(`v1/workTemplates/center/${centerId}`);
    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as GetWorkTemplatesResponse | null,
    };
};

/**
 * @method post
 * @brief 근무 템플릿 생성
 */
export const postWorkTemplate = async ({
    centerId,
    body,
}: {
    centerId: string;
    body: PostWorkTemplateBody;
}) => {
    const res = await apiClient.post(`v1/workTemplates/center/${centerId}`, {
        json: body,
    });
    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as PostWorkTemplateResponse | null,
    };
};

/**
 * @method patch
 * @brief 근무 템플릿 부분 수정
 */
export const patchWorkTemplate = async ({
    centerId,
    templateId,
    body,
}: {
    centerId: string;
    templateId: string;
    body: PatchWorkTemplateBody;
}) => {
    const res = await apiClient.patch(`v1/workTemplates/center/${centerId}/${templateId}`, {
        json: body,
    });
    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as PatchWorkTemplateResponse | null,
    };
};

/**
 * @method delete
 * @brief 근무 템플릿 삭제 (하드)
 */
export const deleteWorkTemplate = async ({
    centerId,
    templateId,
}: {
    centerId: string;
    templateId: string;
}) => {
    const res = await apiClient.delete(`v1/workTemplates/center/${centerId}/${templateId}`);
    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as DeleteWorkTemplateResponse | null,
    };
};
